
export const commontools = {
  methods: {
    getMeta (_meta) {
      const meta = _meta

      if (meta === undefined) {
        return [{ name: 'title', content: '404', id: 'titl' }]
      } else {
        return [
          { name: 'title', content: meta.meta_title, id: 'titl' },
          { name: 'description', content: meta.meta_desc, id: 'desc' },
          { property: 'og:title', content: meta.og_title, id: 'ogtitle' },
          { property: 'og:description', content: meta.og_desc, id: 'ogdesc' },
          { property: 'og:image', content: meta.og_image, id: 'ogimage' },
          { property: 'og:url', content: meta.og_url, id: 'ogurl' },
          { property: 'twitter:card', content: meta.twitter_card, id: 'twcard' },
          { property: 'twitter:site', content: meta.twitter_site, id: 'twsite' },
          { property: 'twitter:title', content: meta.twitter_title, id: 'twtitle' },
          { property: 'twitter:description', content: meta.twitter_desc, id: 'twdesc' },
          { property: 'twitter:image', content: meta.twitter_image, id: 'twimage' }
        ]
      }
    },
    manageWidows () {
      this.arrangeWidows('p')
      this.arrangeWidows('h3')
    },
    preloadImages: function (url) {
      return new Promise(resolve => {
        const image = new Image()
        image.addEventListener('load', () => {
          resolve(image)
        });
        image.src = url
      })
    },
    arrangeWidows (_type) {
      let p = document.getElementsByTagName(_type)
      for (let i = 0; i < p.length; i++) {
        let text = p[i].innerHTML
        let splits = text.split(' ')

        let newText = ''

        splits.map((s, index) => {
          if (index < splits.length - 2) newText += s + ' '
        })

        let lastWord = splits[splits.length - 1]
        let secondlast = splits[splits.length - 2]
        p[i].innerHTML = newText + '<span class="nobr">' + secondlast + ' ' + lastWord + '</span>'
      }
    },
    scrollPercent () {
      let percentscroll = window.scrollY / window.innerHeight
      if (percentscroll >= 1) {
        percentscroll = 1
      }
      return percentscroll
    }
  },
  mounted () {
  }
}
